import { instance } from "api/apiBase";

export interface CodeboxLockbox {
  serial_number: string;
  exists_in_boom: boolean;
}

export type BulkImportStatus =
  | { status: "not_started" }
  | { status: "pending" }
  | {
      status: "done";
      imported_count: number;
      skipped_count: number;
      failed_count: number;
    }
  | { status: "failed"; error: string };

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/codebox";

export const codeboxApi = {
  getLockboxes: async (account_id: number): Promise<CodeboxLockbox[]> => {
    const { data } = await instance.get<CodeboxLockbox[]>(
      `${BASE_ENDPOINT_URL}/lockboxes`,
      { params: { account_id } }
    );
    return data;
  },

  bulkImportLockboxes: async (
    account_id: number,
    serial_numbers: string[]
  ): Promise<void> => {
    await instance.post(`${BASE_ENDPOINT_URL}/lockboxes/bulk_import`, {
      account_id,
      serial_numbers
    });
  },

  getBulkImportStatus: async (): Promise<BulkImportStatus> => {
    const { data } = await instance.get<BulkImportStatus>(
      `${BASE_ENDPOINT_URL}/lockboxes/bulk_import_status`
    );
    return data;
  }
};
